import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import {
  IPaymentSessionRequest,
  MakeMotoPaymentArgs,
} from "./CardPaymentMutator.types"
import { AuthService } from "@/services/AuthService"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import {
  CardPaymentRequestDto,
  PaymentUseCase,
} from "@/api/backofficeRest/generated/model"

export interface ICardPaymentMutator {
  createPaymentSession(
    args: MakeMotoPaymentArgs,
  ): MutationResult<IPaymentSessionRequest>
}

class CardPaymentMutatorClass implements ICardPaymentMutator {
  createPaymentSession(args: MakeMotoPaymentArgs) {
    return useMutation({
      ...BackofficeRestMutations.payments.createPaymentSession(),
      serializerFn: (data: IPaymentSessionRequest): CardPaymentRequestDto => {
        return {
          amountInPence: Math.round(data.amountInPounds * 100),
          email: data.contactEmail ? data.contactEmail : undefined,
          accountId: args.accountCoreId,
          accountNumber: args.accountNumber,
          paymentUseCase: PaymentUseCase.MOTO,
          agentEmail: AuthService.getCurrentUser().username,
          agentName: AuthService.getCurrentUser().name,
          customerName: data.customerName ?? "",
          successRedirectUrl: globalThis.location.href, // to be removed after BE change
          failureRedirectUrl: globalThis.location.href, // to be removed after BE change
        }
      },
      invalidateCache: false,
    })
  }
}

export const CardPaymentMutator = new CardPaymentMutatorClass()
